import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { catchError, map, Observable, of, switchMap } from 'rxjs';

import { ConfigService } from '@features/termination/services';

import * as fromActions from '../../actions';

@Injectable()
export class ConfigEffects {
  private readonly actions$: Actions = inject(Actions);

  private readonly configService: ConfigService = inject(ConfigService);

  public loadConfig$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.ConfigLoad),
      switchMap(() =>
        this.configService.getConfig().pipe(
          map((config) => {
            return fromActions.ConfigLoadComplete({ config });
          }),
          catchError((error) => {
            return of(fromActions.ConfigLoadError({ error }));
          }),
        ),
      ),
    );
  });
}
